import * as types from './constants';

export const batchMessageStatusItem = {
  id: null,
  status: '', // pending, running, completed, failed
  failed_count: null
};

export const batchMessageUserItem = {
  name: '',
  uuid: null
};

const initialState = {
  composer: {
    open: false,
    name: '',
    users: [],
    message: ''
  },
  report: {
    open: false,
    id: null,
    status: '',
    failed_users: []
  },
  status: {
    list: []
  },
  template: {
    open: false,
    id: null,
    edit: false,
    title: '',
    content: ''
  }
};

const actions = {
  // Batch Message Composer
  [types.OPEN_BATCH_MESSAGE_COMPOSER]: (state, { payload }) => {

    const data = {
      ...state,
      composer: {
        ...state.composer,
        open: true,
        users: [...payload.users],
        name: payload.name,
        ...(payload.message && { message: payload.message })
      }
    };

    return { ...data };
  },

  [types.CLOSE_BATCH_MESSAGE_COMPOSER]: state => {
    const data = {
      ...state,
      composer: { ...initialState.composer }
    };

    return { ...data };
  },

  [types.SET_BATCH_MESSAGE_COMPOSER_MESSAGE]: (state, { payload }) => {

    const data = {
      ...state,
      composer: {
        ...state.composer,
        message: payload.message
      }
    };

    return { ...data };
  },

  // Batch Message Report
  [types.OPEN_BATCH_MESSAGE_REPORT]: (state, { payload }) => {

    const data = {
      ...state,
      report: {
        open: true,
        id: payload.id,
        status: payload.status,
        failed_users: [...payload.users]
      }
    };

    return { ...data };
  },

  [types.CLOSE_BATCH_MESSAGE_REPORT]: state => {
    const data = {
      ...state,
      report: { ...initialState.report }
    };

    return { ...data };
  },

  // Batch Message Status
  [types.ADD_BATCH_MESSAGE_STATUS]: (state, { payload }) => {

    const data = {
      ...state,
      status: {
        list: [
          ...state.status.list,
          { ...batchMessageStatusItem, ...payload }
        ]
      }
    };

    return { ...data };
  },

  [types.UPDATE_BATCH_MESSAGE_STATUS]: (state, { payload }) => {
    const updatedList = [...state.status.list].map(item => {
      if (item.id === payload.id) return { ...item, ...payload };
      else return item;
    });

    const data = {
      ...state,
      status: {
        list: updatedList
      }
    };

    return { ...data };
  },

  [types.REMOVE_BATCH_MESSAGE_STATUS]: (state, { payload }) => {
    const updatedList = [...state.status.list].filter(item => item.id !== payload.id);

    const data = {
      ...state,
      status: {
        list: updatedList
      }
    };

    return { ...data };
  },

  //Batch Message Template
  [types.OPEN_BATCH_MESSAGE_TEMPLATE]: (state, { payload }) => {

    const data = {
      ...state,
      composer: {
        ...state.composer,
        open: false
      },
      template: {
        ...initialState.template,
        open: true,
        ...(payload && { ...payload })
      }
    };

    return { ...data };
  },

  [types.SET_BATCH_MESSAGE_TEMPLATE]: (state, { payload }) => {

    const data = {
      ...state,
      template: {
        ...state.template,
        [payload.prop]: payload.value
      }
    };

    return { ...data };
  },

  [types.CLOSE_BATCH_MESSAGE_TEMPLATE]: state => {

    const data = {
      ...state,
      composer: {
        ...state.composer,
        open: true
      },
      template: { ...initialState.template }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};